import { optionTitle_markAsRead } from './MarkAsReadOption.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
let MarkAsReadOption: LazyOption = createLazyOption(
    {
        key: 'markAsRead',
        titleStringKey: optionTitle_markAsRead,
        searchTermsStringKey: optionTitle_markAsRead,
        allowedOptionKeys: ['MarkAsRead'],
    },
    lazyFullModule,
    m => m.default
);
export default MarkAsReadOption;
